import { mombasa } from './mombasa';
import { nairobi } from './nairobi';

// Locations with a live excursion catalogue (shown on the /excursions hub).
export const EXCURSION_LOCATIONS = [mombasa, nairobi];

// Locations the client plans to add later — rendered as "coming soon" on the hub
// so the section signals breadth. Add a data file above and move it here when ready.
export const UPCOMING_LOCATIONS = [
  { slug: 'diani', name: 'Diani' },
  { slug: 'malindi', name: 'Malindi' },
  { slug: 'watamu', name: 'Watamu' },
  { slug: 'tsavo', name: 'Tsavo' },
];

// Real contact details from the client (Mombasa flyer, 2026-08-03).
export const EXCURSION_WHATSAPP = '254112666696';
export const EXCURSION_EMAIL = 'tours@jambotravelhouse.co.ke';

const BY_SLUG = Object.fromEntries(EXCURSION_LOCATIONS.map((loc) => [loc.slug, loc]));

export function getLocation(slug) {
  return BY_SLUG[slug] || null;
}

export function getExcursion(locationSlug, excursionSlug) {
  const location = getLocation(locationSlug);
  if (!location) return null;
  const excursion = location.excursions.find((e) => e.slug === excursionSlug) || null;
  return excursion ? { location, excursion } : null;
}

export function whatsappLink(text) {
  return `https://wa.me/${EXCURSION_WHATSAPP}?text=${encodeURIComponent(text)}`;
}

// Featured excursions for the homepage — featured-flagged first, then filled.
// Each carries its location name + slug for building the product URL.
export function getFeaturedExcursions(limit = 3) {
  const all = EXCURSION_LOCATIONS.flatMap((loc) =>
    loc.excursions.map((e) => ({ ...e, location: loc.name, locationSlug: loc.slug }))
  );
  const featured = all.filter((e) => e.featured);
  const rest = all.filter((e) => !e.featured);
  return [...featured, ...rest].slice(0, limit);
}
